import { render, staticRenderFns } from "./MonitoringMailsPage.vue?vue&type=template&id=15b3518a&scoped=true&"
import script from "./MonitoringMailsPage.vue?vue&type=script&lang=js&"
export * from "./MonitoringMailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b3518a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
